import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DecodeHtmlPipe } from '../../pipes/decode-html.pipe';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs';
import { combineLatest } from 'rxjs';
import { DrupalService } from '../../services/drupal-service/drupal-service';

@Component({
  selector: 'app-pillar-pages-temp',
  standalone: true,
  imports: [CommonModule, DecodeHtmlPipe],
  templateUrl: './pillar-pages-temp.html',
  styleUrl: './pillar-pages-temp.scss',
})
export class PillarPagesTemp {

  private readonly drupalService = inject(DrupalService);
  private readonly route = inject(ActivatedRoute);

  public openStates: boolean[] = [];
  public openStates2: boolean[] = [];
  public currentPath: string = '';

  public readonly viewModel$ = combineLatest([
    this.drupalService.getContent('/' + this.route.snapshot.url.map(segment => segment.path).join('/')),
    this.drupalService.getNavItems()
  ]).pipe(
    map(([content, navItems]) => {
      this.currentPath = '/' + this.route.snapshot.url.map(segment => segment.path).join('/');
      return {
        content: content.map(item => ({
          ...item,
          parsedResources: this.parseResources(item.resources),
          parsedResources2: this.parseResources2(item.resources_2)
        })),
        navItems: navItems,
        activeRootTitle: this.findActiveRoot(navItems)
      };
    })
  );

  public toggleAccordion(index: number) {
    this.openStates[index] = !this.openStates[index];
  }

  public toggleAccordion2(index: number) {
    this.openStates2[index] = !this.openStates2[index];
  }

  public isActive(itemPath: string): boolean {
    return this.currentPath === itemPath;
  }

  public isDuplicateLink(childPath: string, parentPath: string): boolean {
    return childPath === parentPath;
  }

  private findActiveRoot(navItems: any[]): string {
    for (const item of navItems) {
      if (this.isActive(item.relative)) return item.title;
      if (item.below) {
        for (const child of item.below) {
          if (this.isActive(child.relative)) return item.title;
          if (child.below) {
            for (const grandchild of child.below) {
              if (this.isActive(grandchild.relative)) return item.title;
            }
          }
        }
      }
    }
    return 'Future Ready TN';
  }

  private parseResources2(html: string): {accordionTitleHtml: string, items: {title: string, content: string}[]} {
    if (!html) return { accordionTitleHtml: '', items: [] };
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const h4s = doc.querySelectorAll('h4');
    const items: {title: string, content: string}[] = [];
    let accordionTitleHtml = '';

    h4s.forEach((h4, index) => {
      if (this.isAccordionSectionTitle(h4, index)) {
        accordionTitleHtml = this.createAccordionTitleHtml(h4);
        return;
      }
      const title = h4.textContent?.trim() || '';
      let content = '';
      let next = h4.nextElementSibling;
      while (next && next.tagName !== 'H4') {
        content += next.outerHTML;
        next = next.nextElementSibling;
      }
      items.push({title, content});
    });

    this.openStates2 = new Array(items.length).fill(false);
    return { accordionTitleHtml, items };
  }

  private parseResources(html: string): {accordionTitleHtml: string, items: {title: string, content: string}[]} {
    if (!html) return { accordionTitleHtml: '', items: [] };
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const h4s = doc.querySelectorAll('h4');
    const items: {title: string, content: string}[] = [];
    let accordionTitleHtml = '';

    h4s.forEach((h4, index) => {
      if (this.isAccordionSectionTitle(h4, index)) {
        accordionTitleHtml = this.createAccordionTitleHtml(h4);
        return;
      }
      const title = h4.textContent?.trim() || '';
      let content = '';
      let next = h4.nextElementSibling;
      while (next && next.tagName !== 'H4') {
        content += next.outerHTML;
        next = next.nextElementSibling;
      }
      items.push({title, content});
    });

    this.openStates = new Array(items.length).fill(false);
    return { accordionTitleHtml, items };
  }

  private isAccordionSectionTitle(h4: HTMLHeadingElement, index: number): boolean {
    return index === 0 && (
      h4.classList.contains('accordion-title') ||
      h4.textContent?.trim().toLowerCase() === 'resources'
    );
  }

  private createAccordionTitleHtml(h4: HTMLHeadingElement): string {
    return `<h2 class="accordion-title">${h4.innerHTML}</h2>`;
  }
}
